import { Anchor, Shield, Users, AlertTriangle, CheckCircle, Settings, Home, TrendingUp } from 'lucide-react';

/**
 * Icons Section - Icon sizing and stroke weight comparison
 */
export default function IconsSection({ theme }) {
  const isDark = theme === 'dark';

  const icons = [
    { Icon: Anchor, label: 'Anchor' },
    { Icon: Shield, label: 'Shield' },
    { Icon: Users, label: 'Users' },
    { Icon: AlertTriangle, label: 'Alert' },
    { Icon: CheckCircle, label: 'Check' },
    { Icon: Settings, label: 'Settings' },
    { Icon: Home, label: 'Home' },
    { Icon: TrendingUp, label: 'Trending' },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h2 className={`text-2xl font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Icon Comparison
        </h2>
        <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          Standard vs bolder stroke weights
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <div className={`text-xs font-semibold uppercase tracking-wider mb-4 ${
            isDark ? 'text-gray-400' : 'text-gray-500'
          }`}>
            Current (strokeWidth: 2)
          </div>
          <div className="grid grid-cols-4 gap-4">
            {icons.map(({ Icon, label }) => (
              <div key={label} className="flex flex-col items-center gap-2">
                <div className={`p-3 rounded-lg ${isDark ? 'bg-gray-800' : 'bg-gray-100'}`}>
                  <Icon className={isDark ? 'text-gray-300' : 'text-gray-700'} size={24} strokeWidth={2} />
                </div>
                <span className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className={`text-xs font-bold uppercase tracking-wider mb-4 ${
            isDark ? 'text-blue-400' : 'text-blue-600'
          }`}>
            iOS-Style (strokeWidth: 2.5)
          </div>
          <div className="grid grid-cols-4 gap-4">
            {icons.map(({ Icon, label }) => (
              <div key={label} className="flex flex-col items-center gap-2">
                <div className={`p-3 rounded-lg shadow-md ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
                  <Icon className={isDark ? 'text-gray-200' : 'text-gray-800'} size={24} strokeWidth={2.5} />
                </div>
                <span className={`text-xs font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Icon Sizes */}
      <div>
        <h3 className={`text-lg font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Icon Sizes
        </h3>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="flex items-center gap-4">
            <Shield size={16} strokeWidth={2} className="text-blue-600" />
            <Shield size={20} strokeWidth={2} className="text-blue-600" />
            <Shield size={24} strokeWidth={2} className="text-blue-600" />
            <Shield size={32} strokeWidth={2} className="text-blue-600" />
            <Shield size={48} strokeWidth={2} className="text-blue-600" />
          </div>
          <div className="flex items-center gap-4">
            <Shield size={16} strokeWidth={2.5} className="text-blue-600" />
            <Shield size={20} strokeWidth={2.5} className="text-blue-600" />
            <Shield size={24} strokeWidth={2.5} className="text-blue-600" />
            <Shield size={32} strokeWidth={2.5} className="text-blue-600" />
            <Shield size={48} strokeWidth={2.5} className="text-blue-600" />
          </div>
        </div>
      </div>
    </div>
  );
}
